var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitAuthorizeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2297",
    "data-name": "Group 2297",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.153,
    height: 29.153,
    viewBox: "0 0 29.153 29.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M0,0H29.153V29.153H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M13.5,3a1.215,1.215,0,0,1,1.215,1.215v9.718a6.073,6.073,0,1,1,.259,9.9l-.259-.185A1.215,1.215,0,0,1,13.5,24.865H6.215A1.215,1.215,0,0,1,5,23.65V4.215A1.215,1.215,0,0,1,6.215,3ZM12.288,5.429H7.429V22.435h4.859Zm9.718,12.147H14.718v2.429h7.288Z",
    transform: "translate(1.074 0.644)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitAuthorizeIcon);
export default __webpack_public_path__ + "static/media/debit-authorize-icon.fbb947d71fe0c8ebd005cfa53fdead67.svg";
export { ForwardRef as ReactComponent };